import jwtDecode from 'jwt-decode';
import moment from 'moment';

/**
 * Retourne true si la date d'expiration contenue dans le token est dépassé par la date du jour
 * si le format du token n'est pas bon alors jwtDecode lance une exception, on la catche et on retourne true
 * @param {*Token JWT} token
 * exp est un timestamp de la date d'expiration du token en secondes
 */
export function isTokenExpired(token) {
    try {
        return moment().isAfter(moment.unix(jwtDecode(token).exp));
    } catch (e) {
        // token n'est pas au bon format, jwtDecode lance un exception
        // pour nous le token est donc expiré
        console.error(e);
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/services/authentication/utils.js